export default __webpack_public_path__ + "static/media/wide_button_badge.c55e440a.png";